_ = require 'underscore'
Alerts = require 'app/scripts/views/lib/alerts'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
PluginModelSerializer = require 'app/scripts/views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginView = require 'app/scripts/views/plugin/plugin-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
template = require 'app/scripts/views/templates/list_sort'
{ track, trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
l = require 'app/scripts/lib/localize'
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'

CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId

calculateMoves = ({ list, posBefore, posAfter, count }) ->
  for card, cardIndex in list
    card: card
    pos: posBefore + (cardIndex + 1) * (posAfter - posBefore) / (list.length + 1)

# Figure out what moves need to happen to make all the cards in the list sort
# before the last item
getMovesUp = (list, idToPos) ->
  index = list.length - 1

  _.flatten(while index >= 0
    # Find the first card with a pos < posAfter
    endIndex = index
    index--
    while index >= 0 && idToPos[list[index].id] > idToPos[list[endIndex].id]
      index--

    calculateMoves {
      list: list[index + 1...endIndex]
      posBefore:
        if index >= 0
          idToPos[list[index].id]
        else
          0
      posAfter: idToPos[list[endIndex].id]
    }
  )

# Figure out what moves need to happen to make all the cards in the list sort
# after the first item
getMovesDown = (list, idToPos) ->
  index = 0

  _.flatten(while index < list.length
    # Find the first card with a pos > posBefore
    startIndex = index
    index++
    while index < list.length && idToPos[list[index].id] < idToPos[list[startIndex].id]
      index++

    calculateMoves {
      list: list[startIndex + 1...index]
      posBefore: idToPos[list[startIndex].id]
      posAfter:
        if index < list.length
          idToPos[list[index].id]
        else
          idToPos[list[startIndex].id] + Util.spacing * (index - startIndex)
    }
  )

throttled = (list, { fx, updatesPerMinute, concurrency }) ->
  # What's the least time we should spend on a concurrent
  # request to make sure we don't send more than
  # updatesPerMinute requests per minute
  msWait = concurrency * (60 * 1000 / updatesPerMinute)

  Promise.map list, (entry) ->
    start = Date.now()

    Promise.resolve(fx(entry))
    .then ->
      # Delay a bit so we don't send too many updates
      msRemaining = msWait - (Date.now() - start)
      if msRemaining > 0
        Promise.delay(msRemaining)
  , { concurrency }

module.exports = class ListSortView extends PluginView
  viewTitleKey: 'sort list'

  initialize: ->
    @retain @options.pluginListSorters

  events:
    'click .js-sort-by-due-date': 'sortByDueDate'
    'click .js-sort-newest-first': 'sortNewestFirst'
    'click .js-sort-oldest-first': 'sortOldestFirst'
    'click .js-sort-by-card-name': 'sortByCardName'
    'click .js-plugin-list-sort-action': 'sortByPluginSort'

  render: ->
    pluginListSorters = _.chain(@options.pluginListSorters)
      .filter (s) ->
        _.isString(s.text) &&
        s.text.length &&
        _.isFunction(s.callback)
      .map (s) ->
        _.extend(s, {
          image: PluginIOCache.fromId(s.idPlugin).getIconUrl()
          name: PluginIOCache.fromId(s.idPlugin).getName()
        })
      .value()

    pluginListSorters = pluginListSorters.concat(@getCustomFieldSorts())
    if @model.getBoard().isPowerUpEnabled('voting')
      pluginListSorters.push({
        callback: @sortByVotes()
        text: l('templates.list_sort.most-votes')
        image: require('resources/images/powerups/voting-icon.svg')
        name: l('power ups.voting.name')
      })

    @pluginListSorters = _.sortBy(pluginListSorters, 'text')

    @$el.html(template({
      canSortByDueDate: @model.cardList.any((card) => card.get('due'))
      pluginListSorters: @pluginListSorters
    }))

    @

  getCustomFieldSorts: ->
    if !@model.getBoard().isCustomFieldsEnabled()
      return []

    _.chain(@model.getBoard().customFieldList.models)
    .filter (cf) -> cf.isSortable() && cf.visible()
    .map (cf) =>
      if cf.get('type') == 'number'
        [{
          callback: @sortByCustomField(cf.id)
          text: l('templates.list_sort.field-ascending', field: cf.get('name'))
          image: PluginIOCache.fromId(CUSTOM_FIELDS_ID).getIconUrl()
          name: l('view title.custom fields')
        }, {
          callback: @sortByCustomField(cf.id, true)
          text: l('templates.list_sort.field-descending', field: cf.get('name'))
          image: PluginIOCache.fromId(CUSTOM_FIELDS_ID).getIconUrl()
          name: l('view title.custom fields')
        }]
      else
        callback: @sortByCustomField(cf.id)
        text: cf.get('name')
        image: PluginIOCache.fromId(CUSTOM_FIELDS_ID).getIconUrl()
        name: l('view title.custom fields')
    .flatten()
    .value()

  sortByDueDate: (e) ->
    Util.stop(e)
    PopOver.hide()

    track("List Menu", "Sort Cards By Date")

    @applySort =>
      @model.cardList.sortBy (card) ->
        due = card.get('due')
        dueComplete = card.get('dueComplete')

        [
          if due
            if dueComplete
              "1"
            else
              "0"
          else
            "2"

          due ? ""
        ].join(":")

  sortNewestFirst: (e) ->
    Util.stop(e)
    PopOver.hide()

    track("List Menu", "Sort Newest First")

    @applySort (=> @model.cardList.sortBy (card) -> card.id), { reverse: true }

  sortOldestFirst: (e) ->
    Util.stop(e)
    PopOver.hide()

    track("List Menu", "Sort Oldest First")
    @applySort =>
      @model.cardList.sortBy((card) -> card.id)

  sortByCardName: (e) ->
    Util.stop(e)
    PopOver.hide()

    track("List Menu", "Sort By Card Name")
    @applySort =>
      # we'll need to restore the original comparator later, or else every new
      # card will not be inserted at the bottom of the list, but instead
      # alphabetically.
      originalComparator = @model.cardList.comparator
      @model.cardList.comparator = (card1, card2) -> card1.get('name').localeCompare(card2.get('name'))
      @model.cardList.sort()
      @model.cardList.comparator = originalComparator
      @model.cardList.models

  sortByCustomField: (idCustomField, descending) ->
    =>
      trackUe('list menu', 'opens', 'Power-Up', '', '', 'list-sorters', CUSTOM_FIELDS_ID)

      withValue = []
      withoutValue = []
      _.forEach @model.cardList.models, (c) ->
        fieldItem = c.customFieldItemList.find (cfi) -> cfi.get('idCustomField') == idCustomField
        if fieldItem? && !fieldItem.isEmpty()
          withValue.push({ id: c.id, value: fieldItem.getParsedValue() })
        else
          withoutValue.push(c.id)

      sorted = _.chain(withValue)
        .sortBy (c) -> c.value
        .map (c) -> c.id
        .value()

      if descending
        sorted = sorted.reverse()

      sorted = sorted.concat(withoutValue)

      sorted = _.chain(sorted)
        .map((idCard, idx) -> [idCard, idx])
        .object()
        .value()

      @applySort =>
        @model.cardList.sortBy((card) -> sorted[card.id])

  sortByVotes: ->
    =>
      trackUe('list menu', 'opens', 'Power-Up', '', '', 'list-sorters', LegacyPowerUps.voting)

      @applySort =>
        @model.cardList.sortBy (card) ->
          card.get('badges').votes * -1

  sortByPluginSort: (e) ->
    Util.stop(e)

    track("List Menu", "Sort Cards By Plugin")
    index = @$(e.target).closest('.js-plugin-list-sort-action').data('index')
    sort = @pluginListSorters[index]

    if sort.idPlugin
      trackUe('list menu', 'opens', 'Power-Up', '', '', 'list-sorters', sort.idPlugin)
      sendPluginUIEvent(sort.idPlugin, {
        action: 'clicked'
        actionSubject: 'option'
        source: 'listMenuInlineDialog'
        actionSubjectId: 'powerUpListSorter'
        objectType: 'powerUp'
        objectId: sort.idPlugin
      })
      Alerts.show('sorting list', 'warning', 'listsort')
      sort.callback({
        options:
          cards: PluginModelSerializer.cards(@model.cardList.models, ['all'])
      })
      .catch -> {}
      .then (results) =>
        sorted = results?.sortedIds
        actualCards = @model.cardList.models
        if !sorted? || !_.all(sorted, (idCard) -> _.isString(idCard) && /^[a-f0-9]{24}$/.test(idCard)) || !_.all(actualCards, (c) -> c.id in sorted)
          Alerts.hide('listsort')
          Alerts.show('invalid sort order returned', 'warning', 'listsort', 5000)
          PopOver.hide()
          return

        sortLookup = _.chain(sorted)
          .map((idCard, index) -> [idCard, index])
          .object()
          .value()
        @applySort =>
          @model.cardList.sortBy((card) -> sortLookup[card.id])
      PopOver.hide()
    else
      sort.callback()
      PopOver.hide()

  applySort: (getDesiredCards, options = {}) ->
    if @model.cardList.length <= 1
      return

    Alerts.show('sorting list', 'warning', 'listsort')

    desiredCards = getDesiredCards()
    if options.reverse
      desiredCards.reverse()

    # We're doing a lot of pos lookups, so use a simple hash
    idToPos = _.chain(desiredCards)
      .map (card) -> [card.id, card.get('pos')]
      .object()
      .value()

    # We want to optimize for changing as few positions as possible
    # so we'll choose PIVOT_COUNT cards where we sort everything before
    # and everything after, choose the pivot that results in the
    # fewest pos changes
    PIVOT_COUNT = 10

    bestMoves = _.chain([0..PIVOT_COUNT])
      .map (index) =>
        Math.round((desiredCards.length - 1) * index / (PIVOT_COUNT))
      .uniq()
      .map (index) ->
        return [
          getMovesUp(desiredCards[0..index], idToPos)...,
          getMovesDown(desiredCards[index..], idToPos)...
        ]
      .sortBy (entry) -> entry.length
      .first()
      .value()

    # Immediately update the UI
    for { card, pos } in bestMoves
      card.set('pos', pos)

    # Throttle updates so we aren't sending too many at once
    # Lock the model cache so if another sort is started
    # while this one is still running, we don't end up with
    # cards jumping around when the previous updates complete
    Promise.using @modelCache.getLock(), ->
      throttled bestMoves,
        fx: ({ card, pos }) ->
          Promise.fromNode (next) ->
            card.update('pos', card.get('pos'), next)
        updatesPerMinute: 60
        concurrency: 5
    .then ->
      Alerts.hide('listsort')
      Alerts.show('list sorted', 'info', 'listsort', 3000)
